import { render } from "./BrowsChannels.vue?vue&type=template&id=1b38b76b&scoped=true"
import script from "./BrowsChannels.vue?vue&type=script&lang=js"
export * from "./BrowsChannels.vue?vue&type=script&lang=js"

import "./BrowsChannels.vue?vue&type=style&index=0&id=1b38b76b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b38b76b"]])

export default __exports__